import I18n from 'I18n';
import UISelect from 'UIComponents/input/UISelect';
import CRMPropertyValueTypes from 'automation-ui-flow-core/fields/CRMPropertyValueTypes';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const getOperatorOption = operator => {
  switch (operator) {
    case 'IS_EQUAL_TO':
      return {
        value: 'IS_EQUAL_TO',
        text: I18n.text('automation-ui-action-features.action-features.static-branch.operators.IS_EQUAL_TO')
      };
    case 'IS_NOT_EQUAL_TO':
      return {
        value: 'IS_NOT_EQUAL_TO',
        text: I18n.text('automation-ui-action-features.action-features.static-branch.operators.IS_NOT_EQUAL_TO')
      };
    case 'IS_LESS_THAN':
      return {
        value: 'IS_LESS_THAN',
        text: I18n.text('automation-ui-action-features.action-features.static-branch.operators.IS_LESS_THAN')
      };
    case 'IS_GREATER_THAN':
      return {
        value: 'IS_GREATER_THAN',
        text: I18n.text('automation-ui-action-features.action-features.static-branch.operators.IS_GREATER_THAN')
      };
    case 'IS_LESS_THAN_OR_EQUAL_TO':
      return {
        value: 'IS_LESS_THAN_OR_EQUAL_TO',
        text: I18n.text('automation-ui-action-features.action-features.static-branch.operators.IS_LESS_THAN_OR_EQUAL_TO')
      };
    case 'IS_GREATER_THAN_OR_EQUAL_TO':
      return {
        value: 'IS_GREATER_THAN_OR_EQUAL_TO',
        text: I18n.text('automation-ui-action-features.action-features.static-branch.operators.IS_GREATER_THAN_OR_EQUAL_TO')
      };
    default:
      return {
        value: 'IS_EQUAL_TO',
        text: I18n.text('automation-ui-action-features.action-features.static-branch.operators.IS_EQUAL_TO')
      };
  }
};
const getAllowedOperators = type => {
  switch (type) {
    case CRMPropertyValueTypes.ENUM:
    case CRMPropertyValueTypes.BOOL:
    case CRMPropertyValueTypes.DATE:
    case CRMPropertyValueTypes.DATETIME:
    case CRMPropertyValueTypes.STRING:
    case CRMPropertyValueTypes.PHONE_NUMBER:
    case CRMPropertyValueTypes.UNKNOWN:
      return ['IS_EQUAL_TO', 'IS_NOT_EQUAL_TO'];
    case CRMPropertyValueTypes.NUMBER:
      return ['IS_EQUAL_TO', 'IS_NOT_EQUAL_TO', 'IS_LESS_THAN', 'IS_GREATER_THAN', 'IS_LESS_THAN_OR_EQUAL_TO', 'IS_GREATER_THAN_OR_EQUAL_TO'];
    default:
      return ['IS_EQUAL_TO', 'IS_NOT_EQUAL_TO'];
  }
};
const StaticBranchOperatorSelect = ({
  onChange,
  propertyAsAddon,
  value
}) => {
  const type = propertyAsAddon.valueType;
  const allowedOperators = getAllowedOperators(type);
  const operatorOptions = allowedOperators.map(operator => {
    return getOperatorOption(operator);
  });
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "200",
    as: "div",
    children: /*#__PURE__*/_jsx(UISelect, {
      options: operatorOptions,
      value: value,
      onChange: ({
        target: {
          value: newOperator
        }
      }) => onChange(newOperator)
    })
  });
};
export default StaticBranchOperatorSelect;